import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import React from 'react';
import {
  ConsolidatedContact,
  ContactDetailsInput,
  ContactRecommendationsData,
  ContactViewTabType,
} from '../../../../api/CoachingNotes/schema';

import ContextFeedbackModalFormWrapper from './ContextFeedbackModalFormWrapper';

export interface ContactReviewFeedbackModalFormProps {
  open: boolean;
  parentValues: ContactRecommendationsData | ConsolidatedContact;
  parentUserName: string;
  parentUserID: string;
  onFeedbackSubmitted: (feedbackDetails: ContactDetailsInput) => void;
  contactTab: ContactViewTabType;
  contactCategory?: string;
  ingress?: string | null;
}

const ContactReviewFeedbackModal: React.FC<
  ContactReviewFeedbackModalFormProps
> = ({
  open,
  parentValues,
  parentUserName,
  parentUserID,
  onFeedbackSubmitted,
  contactTab,
  contactCategory,
  ingress,
}: ContactReviewFeedbackModalFormProps): React.ReactElement => {
  return (
    <Row>
      <Modal
        title='Recommendation Feedback'
        width={800}
        open={open}
        scrollContainer='viewport'
        aria-describedby='modal-contact-recommendation-feedback-form'
      >
        <Column
          spacing='300'
          alignmentHorizontal='start'
          spacingInset='400 500'
        >
          <Row>
            <ContextFeedbackModalFormWrapper
              onsubmit={onFeedbackSubmitted}
              prevStatus={parentValues.status}
              contactId={parentValues.contactID}
              week={parentValues.calWeek}
              year={parentValues.calYear}
              username={parentUserName}
              userid={parentUserID}
              parentValues={parentValues}
              contactTab={contactTab}
              contactCategory={contactCategory}
              ingress={ingress}
            />
          </Row>
        </Column>
      </Modal>
    </Row>
  );
};

export default ContactReviewFeedbackModal;
